module.exports = __webpack_public_path__ + "images/emoji/house.a0538672e5bf81a9993d.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/house.png
// module id = 1UTc
// module chunks = 14